import React from 'react';
import { useDroppable } from '@dnd-kit/core';

/**
 * Invisible droppable zone for list start/end so the blue drop indicator
 * can appear when the pointer is above the first or below the last task.
 * Uses a modifier class for positioning (no layout space).
 */
export default function ListDropSentinel({ id, position }) {
  const { setNodeRef } = useDroppable({ id });
  return (
    <li
      ref={setNodeRef}
      className={`task-list-drop-sentinel task-list-drop-sentinel-${position}`}
      aria-hidden="true"
      data-sentinel-id={id}
    />
  );
}
